import { Badge, Group, Paper, Radio, Stack, Text } from "@mantine/core";
import { MultiSelect } from "react-hook-form-mantine";

// Audience selector for a campaign: either all attendees or a tag-filtered
// subset. The resolved recipient count is shown in the header badge.
const TargetAudience = ({
  control,
  audienceType,
  onAudienceTypeChange,
  tags,
  totalRecipients,
}) => {
  return (
    <Paper withBorder shadow="md" p="md" radius="md">
      <Group justify="space-between" align="center" mb="sm">
        <Text fw={500}>Target Audience</Text>
        <Group gap="xs">
          <Text size="sm" c="dimmed">
            Recipients:
          </Text>
          <Badge variant="light" size="lg">
            {totalRecipients}
          </Badge>
        </Group>
      </Group>
      <Stack gap="sm">
        <Radio.Group value={audienceType} onChange={onAudienceTypeChange}>
          <Group>
            <Radio value="all" label="All attendees" />
            <Radio value="tags" label="Select by tags" />
          </Group>
        </Radio.Group>

        {audienceType === "tags" && (
          <MultiSelect
            name="targetedTagIds"
            control={control}
            data={
              tags?.map((t) => ({
                value: String(t.id),
                label: `${t.title} (${t.usageCount})`,
              })) || []
            }
            placeholder="Select tags"
            searchable
          />
        )}
      </Stack>
    </Paper>
  );
};

export default TargetAudience;
